import { ReduxThunkType } from '../../types/ReduxThunkType';
import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { Actions } from './actions';
import { Actions as BookingActions } from '../bookings/actions';
import ZoneService, { ZoneMode } from '../../services/ZonesService';
import ProjectSettingsService from '../../services/ProjectSettingsService';

export const getMeansOfTransport = (): ReduxThunkType<void> => async (dispatch) => {
  try {
    dispatch(Actions.getMeansOfTransport());
    const result = await ZoneService.getMeansOfTransport();
    dispatch(Actions.getMeansOfTransportSuccess(result.data.content));
  } catch (error) {
    dispatch(Actions.getMeansOfTransportError(error as RestErrorResponse));
  }
};

export const getDeliveryZones =
  (projectId: number): ReduxThunkType<void> =>
  async (dispatch) => {
    try {
      dispatch(Actions.getDeliveryZones());
      const response = await ProjectSettingsService.getDeliveryZoneSettings(projectId);
      dispatch(Actions.getDeliveryZonesSuccess(response.data.content));
    } catch (error) {
      dispatch(Actions.getDeliveryZonesError(error as RestErrorResponse));
    }
  };

export const manageDeliveryZone =
  (
    projectId: number,
    active: boolean,
    name: string,
    address: string,
    barrierSystemStatus: boolean,
    equipmentId: number,
    mode: ZoneMode,
    zoneId?: number,
    barrierDeviceId?: number
  ): ReduxThunkType<Promise<boolean>> =>
  async (dispatch) => {
    try {
      dispatch(Actions.manageDeliveryZone());
      const response: any = await ZoneService.manageDeliveryZone(
        projectId,
        active,
        name,
        address,
        barrierSystemStatus,
        equipmentId,
        mode,
        zoneId,
        barrierDeviceId
      );
      dispatch(BookingActions.blockBookingSlotSuccess(response.data));
      if (response.data.length > 0) {
        return Promise.resolve(false);
      }
      dispatch(Actions.manageDeliveryZoneSuccess());
      return Promise.resolve(true);
    } catch (error) {
      dispatch(Actions.manageDeliveryZoneError(error as RestErrorResponse));
      return Promise.resolve(false);
    }
  };
